// Module
var code = "<div class=\"flip-card\"> <div class=\"flip-card-inner\"> <div class=\"flip-card-front\"> <span>Leafar</span> </div> <div class=\"flip-card-back\"> <span>Rafael</span> </div> </div> </div> ";
// Exports
export default code;